import { MobilePermissionEnum } from 'constants-permissions';
import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import { PackagedTypeEnum } from '../../../types/properties/PackagedTypeEnum';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';
import {
  CardFormatEntity,
  CardFormatDropdownOptions,
} from 'application-types';
import type { CardFormatOption } from 'application-types';

export { CardFormatEntity, CardFormatDropdownOptions };
export type { CardFormatOption };

const KastleDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Kastle,
  hasCustomUI: true,
  friendlyName: 'Kastle Access Control',
  description: `Defines the properties required for a Kastle integration.`,
  category: IntegrationCategoryEnum.AccessControl,
  platforms: [PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {
    supportPage: {
      friendlyName: 'Support Page',
      type: 'Content',
    },
    isAppleWalletEnabled: {
      hidden: false,
      type: 'Boolean',
      friendlyName: 'Enable Apple Wallet',
      default: false,
    },
    isGoogleWalletEnabled: {
      hidden: false,
      type: 'Boolean',
      friendlyName: 'Enable Google Wallet',
      default: false,
    },
    cardFormat: {
      hidden: false,
      packagedType: PackagedTypeEnum.Dropdown,
      type: 'Option',
      friendlyName: 'Access Credential Type',
      description: 'web.admin.channel.integrations.kastle.cardFormat.description',
      validators: [{ name: 'In', value: CardFormatDropdownOptions }],
    }
  },
  mobilePermissions: [
    MobilePermissionEnum.Bluetooth,
    MobilePermissionEnum.ScheduleExactAlarm,
    MobilePermissionEnum.Location,
    MobilePermissionEnum.AlwaysLocation,
    MobilePermissionEnum.AccessFineLocation,
  ],
  // Google requires us to use specific language requesting background location access before we load the system prompts
  mobilePermissionsRequest:
    'mobile.access.integration.kastle.definition.mobilePermissionsRequest',
};

/**
 * @deprecated Use `KastleDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { KastleDefinition } from 'application-types';`
 */
export default KastleDefinition;
